/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const documentUploadStyle = {
  file: {
    color: "primary.main",
    padding: "8px",
  },
  chooseFile: {
    textAlign: "right",
  },
  input: {
    display: "none",
  },
  label: {
    fontWeight: 400,
    textAlign: "right",
    padding: "0.5rem 0.75rem 0.5rem 0",
  },
  loadingBar: {
    marginLeft: "auto",
    marginTop: "0.5rem",
    maxWidth: "300px",
  },
};

export default documentUploadStyle;
